  let status_recibo_nomina = Object.freeze({
    EN_PROCESO:1,
    PROCESADO:2,
    CERRADO:3,
    TIMBRADO:4,
    ENVIADO:5,
    ERROR:-1
  });
  
  module.exports = { status_recibo_nomina }
  